import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../store/slices/authSlice';
import { PATH } from '../constants/routes';

/**
 * Renders children when not authenticated; otherwise redirects to home.
 */
const UnauthOnlyRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={PATH.HOME} replace />;
  }

  return children;
};

export default UnauthOnlyRoute;
